<template>
    <div
        :data-component="$options.name"
        v-bind="tracking"
    >
        <ms-headline
            v-if="headline"
            type="h2"
            class="mb-24"
        >
            <ms-text :contentTag="headline.text" />
        </ms-headline>
        <ms-item-slider>
            <ms-recommender-item
                v-for="item in items"
                :key="item.exposeeId"
                :item="item"
                :currentUrl="currentUrl"
                :privacyManagerId="serviceData.privacyManagerId"
                :isExposeeOnline="serviceData.isExposeeOnline"
            />
        </ms-item-slider>
    </div>
</template>
<script lang="ts" src="./HydratedRecommender.ts"></script>
